var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":true,"max-width":350,"min-width":350},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('tenant-card',{on:{"TenantCard_selecionarTenant":_vm.selecionarTenant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }